import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

const moments = articles.filter((item) =>
  ["funny", "awkward", "elimination"].includes(item.category),
);

export default function MomentsGrid() {
  return (
    <section id="moments" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          kicker="Highlight Reel"
          title="名场面合集"
          description="笑点、尴尬和临场反应混在一起，才是直播最好看的部分。以下片段按发生时间倒序排列。"
          actionLabel="进入搞笑名场面"
          actionTo="/category/funny"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {moments.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}